import React, { useState } from 'react';
import { Play } from 'lucide-react';
import './YouTubeEmbed.css';

const getEmbedUrl = (videoId) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const params = new URLSearchParams({
    autoplay: '1',
    playsinline: '1',
    controls: '1',
    modestbranding: '1',
    rel: '0',
    iv_load_policy: '3',
    enablejsapi: '1',
  });

  if (origin) {
    params.set('origin', origin);
  }

  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
};

const YouTubeEmbed = ({ videoId, title }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const poster = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  if (isPlaying) {
    return (
      <div className="youtube-embed youtube-embed-active">
        <iframe
          src={getEmbedUrl(videoId)}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      className="youtube-embed youtube-embed-poster"
      onClick={() => setIsPlaying(true)}
      aria-label={`Play ${title}`}
    >
      <img src={poster} alt="" className="youtube-embed-thumb" loading="lazy" />
      <span className="youtube-embed-overlay" aria-hidden="true" />
      <span className="youtube-embed-play">
        <Play size={30} fill="currentColor" strokeWidth={0} />
      </span>
      <span className="youtube-embed-hint">Play video</span>
    </button>
  );
};

export default YouTubeEmbed;
